import {DataTourAnchorEnum} from '@rdcomponents/usertour/data-tour-anchor';
import {TableColumnsType} from 'antd';
import React from 'react';

import {Text} from '../../../../component/text/text';
import {AdditionalInfo} from '../../../../layout/additional-info/additional-info';
import {Locale} from '../../../../provider/locale/localization';

import {FakesTableType} from './fakes-table-type';

export const fakesTableColumns: TableColumnsType<FakesTableType> = [
    {
        dataIndex: 'catalogIcon',
        width: 56,
        align: 'center',
        onCell: () => ({'data-tour': DataTourAnchorEnum.DuplicatesColCatalog} as React.HTMLAttributes<HTMLElement>),
    },
    {
        title: (
            <AdditionalInfo
                leftNode={<Text stringKey="FAKES__RESULTS__COLUMN__SEARCH_DATE" />}
                placement="bottom"
                title={<Locale stringKey="FAKES__RESULTS__COLUMN__SEARCH_DATE__SUBTITLE" />}
            >
                <Locale stringKey="FAKES__RESULTS__COLUMN__SEARCH_DATE__DESCRIPTION" />
            </AdditionalInfo>
        ),
        dataIndex: 'date',
        width: 120,
        onCell: () => ({'data-tour': DataTourAnchorEnum.DuplicatesColDate} as React.HTMLAttributes<HTMLElement>),
    },
    {
        title: <Locale stringKey="FAKES__RESULTS__COLUMN__FOUND_LOCATION" />,
        dataIndex: 'foundLocation',
        onCell: () =>
            ({'data-tour': DataTourAnchorEnum.DuplicatesColFoundLocation} as React.HTMLAttributes<HTMLElement>),
    },
    {
        title: <Locale stringKey="FAKES__RESULTS__COLUMN__MAIN_LOCATION" />,
        dataIndex: 'mainLocation',
        width: 260,
        onCell: () =>
            ({'data-tour': DataTourAnchorEnum.DuplicatesColMainLocation} as React.HTMLAttributes<HTMLElement>),
    },
    {
        title: (
            <AdditionalInfo
                leftNode={<Text stringKey="FAKES__RESULTS__COLUMN__STATUS" />}
                placement="bottom"
                title={<Locale stringKey="FAKES__RESULTS__COLUMN__STATUS__SUBTITLE" />}
            >
                <Locale stringKey="FAKES__RESULTS__COLUMN__STATUS__DESCRIPTION" />
            </AdditionalInfo>
        ),
        align: 'center',
        dataIndex: 'status',
        width: 128,
        onCell: () => ({'data-tour': DataTourAnchorEnum.DuplicatesColStatus} as React.HTMLAttributes<HTMLElement>),
    },
    {
        dataIndex: 'actions',
        width: 216,
    },
];
